import { render, staticRenderFns } from "./ElementConfigurableScalePlanTableColumn.vue?vue&type=template&id=7b60ac36"
import script from "./ElementConfigurableScalePlanTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementConfigurableScalePlanTableColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports